<div class="notificationStateContainer">
    <span class="state" [style.background]="notificationState.color">{{ notificationState.name }}</span>
</div>
